import type { GatewayCommandRecord } from './api';

/** A WAN check's `healthy` and a WireGuard check's `up` are the good outcomes; anything else wants a look. */
export function isGoodVerdict(verdict: GatewayCommandRecord['verdict']): boolean {
  return verdict === 'healthy' || verdict === 'up';
}
